import * as React from 'react';
import { useSelector } from 'react-redux';

import { ShowAllNewbuildingsLink } from '../../../components/NewbuildingsFromDeveloper';
import { selectOfferId } from '../../../selectors';
import { selectNewbuildingFromDeveloperUrl } from '../../../selectors/newObject';
import { trackAllNewbuildingsClick } from '../tracking';

export const ShowAllNewbuildingsLinkContainer: React.FC = () => {
  const offerId = useSelector(selectOfferId);
  const url = useSelector(selectNewbuildingFromDeveloperUrl);

  const handleClick = React.useCallback(() => {
    trackAllNewbuildingsClick({ offerId });
  }, [offerId]);

  return <ShowAllNewbuildingsLink onClick={handleClick} url={url} />;
};
